(function () {
    'use strict';

    angular
        .module('procedureModule')
        .directive('prcProcedure', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);

        directiveScope.selectProcedure = '&';
        directiveScope.selectSection = '&';
        directiveScope.isSelectEnabled = '=?';
        directiveScope.sectionBlocksContent = '=';
        directiveScope.highlight = '=';
        directiveScope.langCode = '@';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', '$timeout', 'procedureService',
                function ($scope, $controller, $timeout, procedureService) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/procedure/prcProcedure.[Template].tpl.html';

                    $scope.noTranslationAvailable = {};

                    // Return empty prefix for english only
                    $scope.getLanguageSuffix = function () {
                        return $scope.langCode === 'EN' ? '' : $scope.langCode;
                    };

                    // Get translated value and manage default
                    $scope.getDisplayValue = function(object, prop, defaultNoSuffix) {
                        var translated = _.get(object, prop + $scope.langCode, null);

                        if ($scope.langCode === 'EN') return translated;

                        var defaultVal = null;

                        if (translated === null) {
                            defaultVal = _.get(object, prop + (defaultNoSuffix ? '' : 'EN'), null);
                        }

                        // No translation but default value
                        if (defaultVal !== null) {
                            $scope.noTranslationAvailable[prop] = true;
                            translated = defaultVal;
                        }

                        return translated;
                    };

                    init();

                    function init() {

                        // Get Linked Reference Documents by Code
                        if ($scope.boxModel.ReferenceDocumentsCodes) {
                            $scope.boxModel.ReferenceDocuments = [];
                            _.each($scope.boxModel.ReferenceDocumentsCodes, function (refDocumentCode) {
                                // Ignore 403 for unpublished Ref Docs, will simply hide in the search results
                                procedureService
                                    .getReferenceDocumentForView(refDocumentCode, { ignoreError: true })
                                    .then(function (refDocument) {
                                        // When using ignoreError, promise returns an empty string when errors occur
                                        if (refDocument.ProcedureID) {
                                            $scope.boxModel.ReferenceDocuments.push(refDocument);
                                        }
                                    });
                            })
                        }

                        // Wait as isBoxClickable is set after this directive is initiated
                        $timeout(function () {
                            $scope.initBoxClickable = $scope.isBoxClickable;
                        });
                    }

                    // Go To Reference Document
                    $scope.goToReferenceDocument = function (refDocument, $event) {
                        if (!$scope.initBoxClickable) return;

                        $event.stopPropagation();
                        $scope.boxContext.onRefDocClick(refDocument);
                    };

                    // On RefDoc Mouse Enter
                    $scope.onRefDocMouseEnter = function () {
                        if (!$scope.initBoxClickable) return;

                        $scope.isBoxClickable = false;
                    };

                    // On RefDoc Mouse Leave
                    $scope.onRefDocMouseLeave = function () {
                        if (!$scope.initBoxClickable) return;

                        $scope.isBoxClickable = $scope.initBoxClickable;
                    };

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'ProceduresManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'Procedure';
                    $controller('BoxTmplController', { $scope: $scope });

                }],
            link: function (scope, elem, attrs) {

                scope.showActions = function () {

                    if (_.isUndefined(attrs.isSelectEnabled)) {
                        return false;
                    }
                    return attrs.isSelectEnabled;
                };

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
